export default __webpack_public_path__ + "static/media/83.c7ca635e.jpg";